import { render, staticRenderFns } from "./GestorCentralizadoAgregarManualModal.vue?vue&type=template&id=044c8e23&"
import script from "./GestorCentralizadoAgregarManualModal.vue?vue&type=script&lang=js&"
export * from "./GestorCentralizadoAgregarManualModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports